import { submitFormToIam, logError } from 'actions';
import { Auth } from 'utils';
import { forms, ActionTypes as types, APIerrorMessages } from 'constants';
import {
  resetAppErrors,
  updatePostAppError,
} from 'actions/setters/updateAppErrors';

const log = { component: 'updatePassword' };

export default (values, isSuperUser) => dispatch => {
  const userGuid = Auth.getUserGuid();
  const userResource = `/users/${userGuid}/password/${
    isSuperUser ? 'override' : 'change'
  }`;

  const body = {
    userGuid,
    currentPassword: values.currentPassword,
    newPassword: values.newPassword,
    confirmNewPassword: values.retypePassword,
  };

  const onSuccess = () => {
    dispatch(resetAppErrors());
  };

  const onError = (error = {}) => {
    if (error !== APIerrorMessages.wrongCurrentPassword) {
      dispatch(logError(types.UPDATE_APP_STATUS_POST_ERROR, { ...log, error }));
    }
    dispatch(updatePostAppError(error));
  };

  return dispatch(
    submitFormToIam(forms.Password, userResource, userGuid, body, {
      onError,
      onSuccess,
    }),
  );
};
